module.exports = __webpack_public_path__ + "df7b0590a73db27f22498332ebfbbab8.svg";